export default "__VITE_ASSET__DJqMegYY__"